import axios, { AxiosError, AxiosInstance } from 'axios';
import appConfig from '../appConfig';
import events from '../constants/events';
import AuthToken from '../models/AuthToken';
import authStorageService from './authStorageService';

const request = axios.create({
  baseURL: appConfig.backendUrl,
  withCredentials: true,
});

const authRequest = axios.create({
  baseURL: appConfig.universeBackendUrl,
  withCredentials: true,
});

const internalRequest = axios.create({
  baseURL: appConfig.universeBackendUrl,
  withCredentials: true,
});

export const refreshAccessToken = async (): Promise<boolean> => {
  const refreshToken = authStorageService.getState()?.refreshToken;
  try {
    await internalRequest.post<AuthToken>('account/refreshToken', { refreshToken });
    return true;
  } catch {
    return false;
  }
};

const applyCommonInterceptors = (requestInstance: AxiosInstance, refreshAccessTokenHandler: () => Promise<boolean>) => {
  requestInstance.interceptors.response.use(undefined, async (error: AxiosError) => {
    switch (error.response?.status) {
      case 401:
        if (await refreshAccessTokenHandler()) {
          try {
            return await request({ ...error.config });
          } catch {
            window.dispatchEvent(new Event(events.logouted));
          }
        } else {
          window.dispatchEvent(new Event(events.logouted));
        }
        break;
      case 404:
        window.dispatchEvent(new Event(events.notFound));
        break;
      case 403:
        window.dispatchEvent(new Event(events.forbidden));
        break;
      default:
        break;
    }

    return Promise.reject(error);
  });
};

/* add auth token to requests TODO: Remove later, once we finishing full migration to SSO */
// request.interceptors.request.use((config) => {
//   const protectedAuthUrls = [
//     'userInfo',
//     'regenerateRecoveryCode',
//     'UserDetails',
//     'UpdateUserDetails',
//     'ChangePassword',
//     'ChangeMfa',
//   ];
//   const { url } = config;

//   if (!url?.startsWith('/account') || protectedAuthUrls.some((authUrl) => url?.endsWith(authUrl))) {
//     const token = authStorageService.getState()?.accessToken;

//     config.headers.set('Authorization', `Bearer ${token}`);
//   }

//   return config;
// });

applyCommonInterceptors(request, refreshAccessToken);
applyCommonInterceptors(authRequest, refreshAccessToken);

export { authRequest };
export default request;
